import { Component, OnInit, Inject } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { MatDialog } from '@angular/material/dialog';
import { Proper } from '../../../../objects';
import { PaginationInstance } from 'ngx-pagination';
import { ProperEditComponent } from '../proper-edit/proper-edit.component';

@Component({
  selector: 'app-proper',
  templateUrl: './proper.component.html',
  styleUrls: ['./proper.component.css']
})
export class ProperComponent implements OnInit {

  public isLoading = false;
  public data: Proper[];


  public searchProofed: boolean;

  public countTotalProofed: number; 
  public countTotalNotProofed: number; 

  private localStorageKey_numberOfRecords = "grid_Propers_lectionaryItems";
  private localStorageKey_searchProofed = "search_Propers_proofed";
  
  public numberOfRecords = 0;
  public pageNumber = 1;  

      constructor(
        public dialog: MatDialog,
        private apiSvc: ApiService
      ) { }

    ngOnInit() {

      this.numberOfRecords = Number(localStorage.getItem(this.localStorageKey_numberOfRecords));
      if (this.numberOfRecords === 0) {
        this.numberOfRecords = 15;
      }

      this.searchProofed = this.GetDefaultOption_SearchProofed();
      
      this.loadElements();
    }

    private loadElements() {
      this.isLoading = true;
      this.apiSvc.get("api/Proper/", null).subscribe(
        (data: Proper[]) => {
          this.data = data;
          console.log(this.data);
          
          this.updateStats();
          
          this.isLoading = false;
        },
        (err) => {
          console.log("error", err);
          this.isLoading = false;
        }
     );
    }
 
    public edit(obj: Proper) {
      console.log(obj); 
      var modal = this.dialog.open(ProperEditComponent)
      modal.componentInstance.loadProper(obj); 

      modal.afterClosed().subscribe((reloadIndex: boolean) => { 
        console.log("modal closed", reloadIndex); 
        if (reloadIndex !== undefined) {
          this.loadElements();
        }  
      });
    }


private GetDefaultOption_SearchProofed() : boolean {
  var proofed = localStorage.getItem(this.localStorageKey_searchProofed);
  if (proofed === "false") {
    return false
  } else if (proofed === "true") {
    return true;
  }
  return null;
}

    private renderPaginationItemStatus(p: any) {
      //console.log("renderPaginationItemStatus", p, this.numberOfRecords ,p.getCurrent());
     
      var currentPage = p.getCurrent();
      var numberOfRecordsInSet = p.getTotalItems();
    
      var startingRecord = ((currentPage - 1) * this.numberOfRecords) + 1;
    
      if (currentPage == 1) {
        startingRecord = 1;
      }
       
      var endingRecord = startingRecord + (this.numberOfRecords - 1);
      if (endingRecord > numberOfRecordsInSet) {
        endingRecord = numberOfRecordsInSet;
      };
     
      return startingRecord + " to " + endingRecord; 
    }
     
    private updateStats() { 
      this.countTotalNotProofed = this.data.filter(s=> s.IsProofed === false).length;
      this.countTotalProofed = this.data.filter(s=> s.IsProofed === true).length;
    }

    public changeProofedOption() {
      localStorage.setItem(this.localStorageKey_searchProofed, this.searchProofed + "");
    }
    
    public changeNumberOfRecords() {
      localStorage.setItem(this.localStorageKey_numberOfRecords, this.numberOfRecords.toString());
    }
     

}
